import http from './http';

export async function listSupervisors(params) {
  const { data } = await http.get('/supervisors', { params });
  return data;
}

export async function createSupervisor(payload) {
  const { data } = await http.post('/supervisors', payload);
  return data;
}

export async function updateSupervisor(id, payload) {
  const { data } = await http.put(`/supervisors/${id}`, payload);
  return data;
}

export async function deleteSupervisor(id) {
  await http.delete(`/supervisors/${id}`);
}

export async function assignResidences(supervisorId, residence_ids) {
  const { data } = await http.post(`/supervisors/${supervisorId}/assign`, { residence_ids });
  return data;
}

export async function listAssignedResidences(supervisorId) {
  const { data } = await http.get(`/supervisors/${supervisorId}/residences`);
  return data;
}

export async function resetSupervisorPassword(supervisorId) {
  const { data } = await http.post(`/supervisors/${supervisorId}/reset-password`);
  return data;
}

export async function listSupervisorsAudit(params) {
  const { data } = await http.get('/supervisors/audit', { params });
  return data;
}

export async function getAbsenceStats(params) {
  const { data } = await http.get('/admin/absence-stats', { params });
  return data;
}
